module.exports = __webpack_public_path__ + "static/install-a7185098ac47f253ab59e78b5b5df027.jpg";